if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.handler = this.handler.bind(this)
        this.addPersonalisation = this.addPersonalisation.bind(this)

        this.config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        }

        this.form = this.querySelector('[data-type="add-to-cart-form"]');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.querySelector('[type="submit"]').setAttribute('aria-haspopup', 'dialog');
        this.submitButton = this.form.querySelector('[type="submit"]');

        this.form.addEventListener('submit', this.handler);

        this.personalise = this.querySelector('[data-type="personalise-form"]');

        if (this.personalise) {
          this.personaliseButton = this.personalise.querySelector('[type="submit"]')
          this.personaliseJson = JSON.parse(this.personalise.querySelector('[type="application/ld+json"]').innerHTML)

          this.personalise.addEventListener('submit', (evt) => this.personliseHandler(evt, true));
        }

        this.cart = document.querySelector('cart-drawer');
      }

      async personliseHandler(evt) {
        evt.preventDefault()

        // Exit if no personalise settings
        if (this.personaliseData.variant == null) {
          this.handleErrorMessage('Please enter a value in at least one of the above text fields', this.personalise);
          return
        }

        // Prep buttons
        this.beforeAdd()

        // Get cart levels for to-be-added item
        this.cartResponse = await this.checkCart()

        // Add product
        this.productResponse = await this.addProduct()

        // Get cart levels after adding the product
        this.cartResponseElectricBoogaloo = await this.checkCart()

        // Get number of items added
        this.addedToCart = this.cartResponseElectricBoogaloo.inCart - this.cartResponse.inCart

        if (this.addedToCart > 0) {
          this.personalisedResponse = await this.addPersonalisation()
          const ev = new CustomEvent('modal:close')
          this.personalise.querySelector('[data-controller="modal"]').dispatchEvent(ev)
        }

        this.after(this.personalisedResponse)
      }

      async handler(evt) {
        evt.preventDefault()

        // Prep buttons
        this.beforeAdd()

        // Add product
        this.productResponse = await this.addProduct()

        if (this.productResponse) {
          this.after(this.productResponse)
        }
      }

      async checkCart() {
        const obj = {}
        obj.sections = this.cart.getSectionsToRender().map((section) => section.id)
        obj.sections_url = window.location.pathname

        return await fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((response) => {
          const formData = new FormData(this.form)
          const toAdd = Number(formData.get('quantity'))
          let inCart = 0

          for (let index = 0; index < response.items.length; index++) {
            const obj = response.items[index];
            if (formData.get('id') == obj.id) {
              inCart = obj.quantity
            }
          }

          return { toAdd, inCart }
        })
        .catch((error) => { console.error('Error:', error) })
      }

      async addProduct() {
        this.formData = this.parseFormdata(new FormData(this.form))
        this.formData.sections = this.cart.getSectionsToRender().map((section) => section.id)
        this.formData.sections_url = window.location.pathname

        return await fetch(window.Shopify.routes.root + 'cart/add.js', {
          ...this.config,
          body: JSON.stringify(this.formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)
            this.handleErrorMessage(response.description, this.personalise)
            return response;
          }

          this.error = false;
          return response
        })
        .catch((error) => { console.error('Error:', error) })
      }

      async addPersonalisation() {
        this.handleErrorMessage('', this.personalise);
        const formData = new FormData(this.form)
        const personaliseFormData = new FormData(this.personalise)

        const obj = {}
        obj.items = []

        // set data
        const base = {}
        base.quantity = this.addedToCart
        base.properties = {
          "Line item": formData.get('id'),
          "Type": personaliseFormData.get('properties[Font]'),
          ...this.personaliseData.properties
        }

        // get variant id
        const object = this.personaliseJson.variants.filter((o) => o.title.toLowerCase() == this.personaliseData.variant)
        if (object.length == 0) {
          return
        }
        base.id = object[0].id

        obj.items.push(base)

        // set cart refresh data
        obj.sections = this.cart.getSectionsToRender().map((section) => section.id)
        obj.sections_url = window.location.pathname

        return await fetch(window.Shopify.routes.root + 'cart/add.js', {
          ...this.config,
          body: JSON.stringify(obj)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description, this.personalise);
            return;
          }

          this.error = false;
          return response
        })
        .catch((error) => { console.error('Error:', error) })
      }

      after(response) {
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

        if (this.personalise) {
          this.personaliseButton.classList.remove('loading');
          this.personaliseButton.querySelector('.loading__spinner').classList.add('hidden');
        }

        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

        this.cart.renderContents(response);
      }

      beforeAdd() {
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.personalise) {
          this.personaliseButton.setAttribute('aria-disabled', true);
          this.personaliseButton.classList.add('loading');
          this.personaliseButton.querySelector('.loading__spinner').classList.remove('hidden');
        }

        this.cart.setActiveElement(document.activeElement);
      }

      parseFormdata(formData) {
        const obj = {}
        obj.items = []

        const base = {}
        base['id'] = formData.get('id')
        base['quantity'] = formData.get('quantity')

        // Add all properties from the form (including recipient form properties)
        const properties = {}
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propertyName = key.slice(11, -1) // Remove 'properties[' and ']'
            properties[propertyName] = value
          }
        }

        if (Object.keys(properties).length > 0) {
          base['properties'] = properties
        }

        obj.items.push(base)

        return obj
      }

      handleErrorMessage(errorMessage = false, form = this.form) {
        this.error = true
        const errorMessageWrapper = form.querySelector('.product-form__error-message-wrapper');
        if (!errorMessageWrapper) return;

        const errorMessageEl = errorMessageWrapper.querySelector('.product-form__error-message');

        errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if (typeof errorMessage === 'object') {
            // Handle object error messages
            const errorHtml = Object.entries(errorMessage)
              .map(([key, value]) => `<strong>${key.charAt(0).toUpperCase() + key.slice(1)}:</strong> ${value}`)
              .join('<br>');
            errorMessageEl.innerHTML = errorHtml;
          } else {
            // Handle string error messages
            errorMessageEl.textContent = errorMessage;
          }
        }
      }

      get personaliseData() {
        const personaliseFormData = new FormData(this.personalise)
        let front = personaliseFormData.get('properties[Front]').trim()
        let back = personaliseFormData.get('properties[Back]').trim()

        const obj = {}
        obj.variant = null
        obj.properties = {}

        if (front.length > 0) {
          obj.variant = 'front'
          obj.properties['Front'] = front
        }

        if (back.length > 0) {
          obj.variant = 'back'
          obj.properties['Back'] = back
        }

        if (back.length > 0 && front.length > 0) {
          obj.variant = 'front & back'
        }

        return obj
      }
    }
  );
}
